module.exports = __webpack_public_path__ + "static/media/AND.20b3021a.svg";